import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
} from "reactstrap";

// Pages Components
import WelcomeComp from "./WelcomeComp";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";

// redux
import { useSelector, useDispatch } from "react-redux";

// Redux Actions (DLAvia Yapısına Göre)
import {
  getUsers as onGetUsers,          // Users Tablosu
  getBlogs as onGetQuestions,      // Question Tablosu (Genelde blogs state'ine maplenir)
  getAuthority as onGetReports,    // Users_Question_Report Tablosu (Genelde authlist state'ine maplenir)
} from "store/contacts/actions";

const Dashboard = props => {
  const dispatch = useDispatch();

  // Redux Store'dan verileri çekiyoruz
  const { users, questions, reports } = useSelector(state => ({
    users: state.contacts.users,       // Kullanıcı Listesi
    questions: state.contacts.blogs,   // Soru Listesi
    reports: state.contacts.authlist,  // Sınav Raporları
  }));


    // Premium Üye Sayısını Hesapla
  const premiumUsersCount = useMemo(() => {
    if (!users || users.length === 0) return 0;
    
    const now = new Date();
    return users.filter(user => {
      // Kullanıcının abonelikleri var mı kontrol et
      if (!user.User_Subscription || user.User_Subscription.length === 0) return false;
      
      // En güncel aboneliği veya herhangi bir aktif aboneliği bul
      return user.User_Subscription.some(sub => {
        const endDate = new Date(sub.End_Date);
        // Hem IsActive true olmalı hem de bitiş tarihi geçmemiş olmalı
        return sub.IsActive === true && endDate > now;
      });
    }).length;
  }, [users]);

  // İstatistik Kartları Verisi
  const dashboardReports = [
    {
      title: "Toplam Kullanıcı",
      iconClass: "bx-user",
      description: users ? users.length : 0,
      color: "primary"
    },
    {
      title: "Sistemdeki Sorular",
      iconClass: "bx-question-mark",
      description: questions ? questions.length : 0,
      color: "success"
    },
    {
      title: "Tamamlanan Sınavlar",
      iconClass: "bx-file", 
      description: reports ? reports.length : 0,
      color: "warning"
    },
   {
      title: "Premium Üyeler", 
      iconClass: "bx-crown",
      description: premiumUsersCount, // Hesaplanan sayı buraya gelecek
      color: "info"
    },
  ];



  useEffect(() => {
    // Sayfa yüklendiğinde verileri çek
    if (!users || !users.length) {
      dispatch(onGetUsers());
    }
    if (!questions || !questions.length) {
      dispatch(onGetQuestions());
    }
    if (!reports || !reports.length) {
      dispatch(onGetReports());
    }
  }, [dispatch, users, questions, reports]);

  // Meta Title
  document.title = "Anasayfa | DLAvia Yönetim Paneli";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumb */}
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Kontrol Paneli")}
          />

          <Row>
            {/* Sol Taraf - Karşılama Mesajı */}
            <Col xl="4">
              <WelcomeComp />
            </Col>

            {/* Sağ Taraf - İstatistik Kartları */}
            <Col xl="8">
              <Row>
                {dashboardReports.map((report, key) => (
                  <Col md="6" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {props.t(report.title)}
                            </p>
                            <h4 className="mb-0">{report.description}</h4>
                          </div>
                          <div className={`avatar-sm rounded-circle bg-${report.color} align-self-center mini-stat-icon`}>
                            <span className={`avatar-title rounded-circle bg-${report.color}`}>
                              <i className={"bx " + report.iconClass + " font-size-24"}></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* İsterseniz buraya son eklenen sorular veya son sınavlar tablosu ekleyebilirsiniz */}
          
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);